import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { MenuItem, ProductItem } from "../ui/Navbarmenu";
import { logo } from '../../assets/svg';
import { headerLinks } from '../../constants';
import { IoIosArrowBack, IoIosArrowForward } from '../icons';
import { useStateContext } from '../../context/ContextProvider';
import MoodToggle from './MoodToggle';
import LanguageToggle from './LanguageToggle';

import GradiantButton from './GradiantButton';


import MenuButton from './MenuButton';

const Header = ({ activeLink }) => {
  const { currentLang ,currentMode } = useStateContext();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
const isDarkMode = currentMode === 'Dark';
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const [active, setActive] = useState(null);
  return (
    <div className="MainHeader xl:px-10 lg:px-6 px-4 xl:pt-4 pt-2  fixed w-full">
      <div className="w-full py-4 px-6 md:px-8 bg-gradient-to-b from-light-glass1 to-light-glass2 border border-light-glassStrock2 dark:bg-gradient-to-b dark:from-dark-glass1 dark:to-dark-glass2 dark:border-dark-glassStrock1  rounded-full  items-center justify-between flex shadow-md flex-wrap gap-4 md:gap-0 relative backdrop-blur-xl">
        
        <div className="flex-shrink-0 flex items-center space-x-2 order-1 md:order-none">
          <img
            src={logo}
            alt="Manafith Logo"
            className="h-10 w-auto"
          />
        </div>

  <MenuButton onClick={toggleMenu} isMenuOpen={isMenuOpen} />
  
        <nav className="hidden md:flex items-center justify-center gap-4 order-3 md:order-none w-full md:w-auto mt-4 md:mt-0"

        >
          {headerLinks.map((link) => (
            <Link to={link.path}
            onClick={() => {
              window.scrollTo(0, 0);
            }}
            >
              
                 <MenuItem activeLink={activeLink === link.path} setActive={setActive} active={active} item=   {currentLang === 'ar' ? link.nameAr : link.nameEn}>
             <ProductItem
                   setActive={setActive}
              title={currentLang === 'ar' ? link.nameAr : link.nameEn}
              href={link.path}
              src={isDarkMode ?link.image_Dark :link.image}
              description= {currentLang === 'ar' ? link.description_Ar : link.description_En}/>
          </MenuItem>
            </Link>
      
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3 order-4 md:order-none">
          <MoodToggle />
          <LanguageToggle />
          <GradiantButton textSize={""} text={"Login system"} icon={currentLang === "en" ? <IoIosArrowForward size={20} /> : <IoIosArrowBack size={20}/>} />
        </div>


{isMenuOpen && (
  <div className="fixed inset-0  top-16 bg-black/20  z-50 md:hidden animate-fadeIn">
    <div className="absolute mx-2 top-2 left-0 right-0 bg-light-secondary dark:bg-dark-secondary backdrop-blur-xl border border-light-glassStrock2 dark:border-dark-glassStrock1  shadow-xl rounded-2xl overflow-hidden animate-slideDown">
      
      <nav className="py-3">
        {headerLinks.map((link, index) => (
          <div 
            key={link.id} 
            className={`px-5 py-3 flex items-center ${index === headerLinks.length - 1 ? "" : "border-b border-light-strock/20 dark:border-dark-strock/20"} ${active === link.path ? "bg-light-blue/10 text-light-blue" : "text-light-subtitle dark:text-dark-subtitle hover:bg-light-glass2 dark:hover:bg-dark-glass2"} transition-all duration-200`}
            onClick={() => setIsMenuOpen(false)}
          >
            <Link 
              to={link.path} 
              className="flex justify-between items-center w-full py-1"
              onClick={() => {
                window.scrollTo(0, 0);
              }}
            >
              <span className="h7 ">
                {currentLang === 'ar' ? link.nameAr : link.nameEn}
              </span>
              <span className={`transform transition-transform ${active === link.path ? "scale-110 text-light-blue" : "text-light-subtitle/70 dark:text-dark-subtitle/70"}`}>
                {link.icon}
              </span>
            </Link>
          </div>
        ))}
      </nav>
      
      <div className="p-4 border-t border-light-strock/30 dark:border-dark-strock/30">
        <div className="flex justify-center gap-6 py-1">
          <MoodToggle />
          <LanguageToggle />
        </div>
      </div>
    </div>
  </div>
)}
      </div>
    </div>
  );
};

export default Header;